<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">1:1 문의하기</span>
            <span class="txt">센터 admin의 1:1 문의글을 확인하고 작성 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="!qnaList"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn blue" to="/madmin/qna/edit">글쓰기</router-link>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: 1000px" />
                    <col style="width: 205px" />
                    <col style="width: 205px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>등록일</th>
                        <th>제목</th>
                        <th>글쓴이</th>
                        <th>조회수</th>
                    </tr>
                </thead>
                <tbody>
                    <!--                    <tr>-->
                    <!--                        <td>2019-07-17</td>-->
                    <!--                        <td>-->
                    <!--                            <a href="/madmin/notice/detail" class="ic-link">-->
                    <!--                                <span class="ic">공지사항</span>-->
                    <!--                                <span class="txt new">핏투데이케어 사용자 설문조사에 참여해주세요 마니마니 참여해주세요 감사합니다 하나둘셋넷다섯여섯 감사합니다</span>-->
                    <!--                            </a>-->
                    <!--                        </td>-->
                    <!--                        <td>핏투데이케어</td>-->
                    <!--                        <td>100</td>-->
                    <!--                    </tr>-->
                    <!--                    <tr>-->
                    <!--                        <td>2019-07-17</td>-->
                    <!--                        <td>-->
                    <!--                            <a href="/madmin/notice/detail" class="ic-link">-->
                    <!--                                <span class="ic">업데이트</span>-->
                    <!--                                <span class="txt">핏투데이케어 사용자 설문조사에 참여해주세요</span>-->
                    <!--                            </a>-->
                    <!--                        </td>-->
                    <!--                        <td>핏투데이케어</td>-->
                    <!--                        <td>100</td>-->
                    <!--                    </tr>-->
                    <!--                    <tr>-->
                    <!--                        <td>2019-07-17</td>-->
                    <!--                        <td>-->
                    <!--                            <a href="/madmin/notice/detail" class="ic-link">-->
                    <!--                                <span class="lock"><span class="blind">잠금</span></span>-->
                    <!--                                <span class="txt reply">핏투데이케어 사용자 설문조사에 참여해주세요 마니마니 참여해주세요 감사합니다 하나둘셋넷다섯여섯 감사합니다</span>-->
                    <!--                            </a>-->
                    <!--                        </td>-->
                    <!--                        <td>핏투데이케어</td>-->
                    <!--                        <td>100</td>-->
                    <!--                    </tr>-->
                    <!--                    <tr>-->
                    <!--                        <td>2019-07-17</td>-->
                    <!--                        <td>-->
                    <!--                            <a href="/madmin/notice/detail" class="ic-link">-->
                    <!--                                <span class="lock"><span class="blind">잠금</span></span>-->
                    <!--                                <span class="ic">업데이트</span>-->
                    <!--                                <span class="txt new reply">핏투데이케어 사용자 설문조사에 참여해주세요 마니마니 참여해주세요 감사합니다 하나둘셋넷다섯여섯 감사합니다</span>-->
                    <!--                            </a>-->
                    <!--                        </td>-->
                    <!--                        <td>핏투데이케어</td>-->
                    <!--                        <td>100</td>-->
                    <!--                    </tr>-->
                    <tr v-for="(qna, index) in qnaList" :key="index">
                        <td>{{ qna.b_cre_dt | timestampFilter }}</td>
                        <td>
                            <a
                                v-if="qna.b_id == qna.b_parent_id"
                                class="ic-link"
                                @click="onClickParentQna(qna.b_id, qna.b_center_id, qna.b_staff_id)"
                            >
                                <span class="ic">{{ qna.b_cate_nm }}</span>
                                <span :class="{ txt: true, new: newPost(qna.b_cre_dt) }" style="cursor: pointer">
                                    {{ qna.b_title }}
                                </span>
                            </a>
                            <a
                                v-else-if="qna.b_id != qna.b_parent_id"
                                class="ic-link"
                                @click="onClickReplyQna(qna.b_id, qna.b_center_id, qna.b_staff_id, qna.b_parent_id)"
                            >
                                <span class="lock"><span class="blind">잠금</span></span>
                                <span class="ic">{{ qna.b_cate_nm }}</span>
                                <span
                                    :class="{
                                        txt: true,
                                        new: newPost(qna.b_cre_dt),
                                        reply: qna.b_id != qna.b_parent_id,
                                    }"
                                    style="cursor: pointer"
                                >
                                    {{ qna.b_title }}
                                </span>
                            </a>
                        </td>
                        <td>{{ qna.b_staff_nm === 'admin' ? '핏투데이케어' : qna.b_staff_nm }}</td>
                        <td>{{ qna.b_view_cnt }}</td>
                    </tr>
                    <tr v-if="qnaList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn blue" to="/madmin/qna/edit">글쓰기</router-link>
                </div>
            </div>
        </div>
        <b-pagination
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
        ></b-pagination>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { calcNewPost } from '@/assets/js/validation.js';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'qnaList',
    props: {},
    computed: {
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
        cId() {
            return this.$store.getters['auth/cId'];
        },
        staffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    data() {
        return {
            careAuth: false,
            loginCenterId: '',
            loginStaffId: '',
            qnaList: null,
            pagingInfo: { ...pagingInfo },
        };
    },
    mounted() {
        if (this.isCareAdmin || this.isSystemAdmin) {
            // 케어 권한 확인
            this.careAuth = true;
        }
        this.loginCenterId = parseInt(this.cId); // 현재 로그인한 사용자의 센터 Id
        this.loginStaffId = parseInt(this.staffId); // 현재 로그인한 사용자의 staffId
        this.fetchQnaList();
    },
    methods: {
        // 최근 게시글(N) 표시 위한 날짜 계산, true면 새 게시글
        newPost(creDt) {
            return calcNewPost(creDt);
        },

        // 1:1문의하기 목록 Fetch
        async fetchQnaList() {
            try {
                const { data } = await this.getQnaList();
                this.setPageParams(data);
                this.qnaList = data.items;
            } catch (error) {
                console.log(error);
            }
        },

        // 1:1문의하기 목록 조회 API 호출
        getQnaList() {
            return api.get('/admin/api/ft/board/qna', {
                params: {
                    ...this.pagingInfo,
                },
            });
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchQnaList();
        },

        // 페이징 Param set
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 부모글 클릭시 권한 체크
        onClickParentQna(qnaId, centerId, staffId) {
            if (this.careAuth === true || (this.loginCenterId === centerId && this.loginStaffId === staffId)) {
                this.$router.push(`/madmin/qna/detail/${qnaId}`);
            } else {
                alert('권한이 없습니다.');
            }
        },

        // 답변글 클릭시 권한 체크
        onClickReplyQna(qnaId, centerId, staffId, parentId) {
            if (this.careAuth === true || (this.loginCenterId === centerId && this.loginStaffId === staffId)) {
                this.$router.push({ path: `/madmin/qna/detail/${qnaId}`, query: { replyQnaId: parentId } });
            } else {
                alert('권한이 없습니다.');
            }
        },
    },
};
</script>
<style lang="scss"></style>
